import React from 'react';
import GroupStack from './Stacks/GroupStack';
import OverlapStack from './Stacks/OverlapStack';
import ImgLoader from 'components/common/ImgLoader';
import Video from 'components/common/Video';
import { SmallScreen } from 'utils/responsive-mq';

const Chunk = ({ type, images, video }) => {
	switch (type) {
		case 'v-stack':
			return <StackChunk type="v-stack" list={images} />;

		case 'sbs-stack':
			return <StackChunk type="sbs-stack" list={images} />;

		case 'video':
			return (
				<div className={"Chunk style-video style-single-l"}>
					<div className="Image">
						<Video url={video} />
					</div>
				</div>
			)

		default:
			return (
				<div className={"Chunk style-"+type}>
					<Images list={images} />
				</div>
			);
	}
}

const Images = ({ list = [] }) => {
	return (
		<SmallScreen>
			{(match) => {
				return list.map( (item, index) => {
					const image = item.image;
					const aspect = image.width / image.height;
					const style = (match)? {
						width: (aspect<1) ? aspect*100+'%' : '100%'
					} : {}
					return (
						<div key={index} className="Image" style={style}><ImgLoader {...image} wait={false} /></div>
					)
				} );
			}}
		</SmallScreen>
	)
}

const StackChunk = ({type, list}) => {
	if ( !list ) return null;
	const ratios = list.map( item => (item.image.width / item.image.height) );
	const hasLandscape = ratios.filter( val => (val >= 1.25) ).length > 0;
	const hasPortrait = ratios.filter( val => (val <= 0.8) ).length > 0;
	
	const chunkClasses = ['Chunk', 'style-stack'];
	chunkClasses.push( 'style-'+type );
	chunkClasses.push( ( hasLandscape )? 'has-landscape' : 'no-landscape' );
	chunkClasses.push( ( hasPortrait )? 'has-portrait' : 'no-portrait' );
	
	const chunk = (type === 'sbs-stack')? 
		<GroupStack list={list} /> :
		<OverlapStack list={list} />;

	return (
		<div className={chunkClasses.join(' ')} style={{position: 'relative'}}>
			{chunk}
		</div>
	)
}

export default Chunk;


// WEBPACK FOOTER //
// ./src/components/Pages/Project/Chunks/Chunk.jsx